import {DateParser} from "./date-parser";
import {GermanDateParser} from "./german-date-parser";
import localeDe from '@angular/common/locales/de';

import localeDeAt from '@angular/common/locales/de-AT';
import localeDeCh from '@angular/common/locales/de-CH';
import localeEn from '@angular/common/locales/en';
import localeEnGb from '@angular/common/locales/en-GB';

import {EnglishDateParser} from "./english-date-parser";
import {Iso8601DateParser} from "./iso8601-date-parser";

class Options {
  public dataParser: DateParser;
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  public commonLocale: ({} | undefined)[];

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  private constructor(dataParser: DateParser, commonLocale: ({} | undefined)[]) {
    this.dataParser = dataParser;
    this.commonLocale = commonLocale;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  public static of(dataParser: DateParser, commonLocale: ({} | undefined)[]): Options {
    return new Options(dataParser, commonLocale);
  }
}

export class Locale {

  public static readonly de = new Locale('de', null, Options.of(new GermanDateParser(), localeDe));
  public static readonly de_DE = new Locale('de', 'DE', Options.of(new GermanDateParser(), localeDe));
  public static readonly de_AT = new Locale('de', 'AT', Options.of(new GermanDateParser(), localeDeAt));
  public static readonly de_CH = new Locale('de', 'CH', Options.of(new GermanDateParser(), localeDeCh));
  public static readonly en = new Locale('en', null, Options.of(new EnglishDateParser(), localeEn));
  public static readonly en_GB = new Locale('en', 'GB', Options.of(new EnglishDateParser(), localeEnGb));
  public static readonly en_UK = new Locale('en', 'UK', Options.of(new EnglishDateParser(), localeEnGb));

  private static readonly FALLBACK = new Locale('en', null, Options.of(new Iso8601DateParser(), localeEn));
  private static readonly LOCALES = [Locale.de, Locale.de_DE, Locale.de_AT, Locale.de_CH, Locale.en, Locale.en_GB, Locale.en_UK];

  public readonly languageCode: string;
  public readonly countryCode: string | null = null;

  private readonly options: Options;

  private constructor(languageCode: string, countryCode: string | null, options: Options) {
    this.languageCode = languageCode;
    this.countryCode = countryCode;
    this.options = options;
  }

  public static of(languageCode: string, countryCode: string | null): Locale {
    const found = Locale.LOCALES.find((l: Locale) => l.languageCode === languageCode && l.countryCode === countryCode);
    return found ? found : Locale.FALLBACK;
  }

  public getCommonLocale(): (any | undefined)[] {
    return this.options.commonLocale;
  }

  public getDateParser(): DateParser {
    return this.options.dataParser;
  }
}
